import { ClientsProjectListNavBar } from "@src/components/modules/projects/list-for-client/ClientsProjectListNavBar";
import { ProjectTableForClients } from "@src/components/modules/projects/list-for-client/ProjectTableForClients";
import { DataTable, LoadingOverlay } from "@src/components/ui-kit";
import { useStore, useUpdateURI } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { Fragment, useEffect } from "react";

export const ProjectListForClients = observer(function ClientsList() {
  const { projectListingForClientsStore: store } = useStore();
  useUpdateURI(store.searchParams, "id");

  useEffect(() => {
    store.fetchData();
    store.fetchFilterOptions();
  }, []);

  return (
    <Fragment>
      <LoadingOverlay isLoading={store.isLoading} />
      <DataTable>
        <DataTable.NavBar>
          <ClientsProjectListNavBar />
        </DataTable.NavBar>
        <ProjectTableForClients />
      </DataTable>
    </Fragment>
  );
});
